/* global axios */
import ApiClient from './ApiClient';

class VoiceAPI extends ApiClient {
  constructor() {
    super('voice', { accountScoped: true });
  }

  generate_tokens(params){
    return axios.get(`${this.url}/generate_tokens`,{params});
  }
  call_evaluation(payload){
    return axios.post(`${this.url}/call_evaluation`,payload);
  }
  initiate_call(payload){
    return axios.post(`${this.url}/initiate_call`,payload);
  }

  end_call(voice_id){
    return axios.delete(`${this.url}/${voice_id}`,);
  }


}

export default new VoiceAPI();

